// eslint-disable-next-line
export const isProduction = () => process.env.NODE_ENV === 'production';

export const getAncestorByAttr = (el, dataAttr) => {
  while ((el = el.parentElement) && !el.getAttribute(dataAttr)) {} // eslint-disable-line
  return el;
};

const isTextNode = node => node.nodeType === 3;

export function getNextSiblings(elem, filter) {
  const siblings = [];
  while ((elem = elem.nextSibling)) {
    if (isTextNode(elem)) continue;
    if (!filter || filter(elem)) siblings.push(elem);
  }
  return siblings;
}

export function getSiblings(elem) {
  const siblings = [];
  let node = elem.parentNode.firstChild;

  while (node) {
    if (node !== elem && !isTextNode(node)) {
      siblings.push(node);
    }
    node = node.nextElementSibling || node.nextSibling;
  }

  return siblings;
}



// WEBPACK FOOTER //
// ./src/utils/index.js